'use client';
import {
  GOOGLE_RECAPTCHA_SITE_KEY,
  hasCaptchaSiteKey,
} from '@utils/getCaptchaSiteKey';
import {datadogLogs} from '@datadog/browser-logs';
import React, {ReactNode, useEffect} from 'react';
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from 'react-google-recaptcha-v3';

interface RecaptchaProps {
  onVerify: (token: string) => void;
  refreshReCaptcha?: boolean;
}

export const RecaptchaProvider = (props: {children: ReactNode}) => {
  if (!hasCaptchaSiteKey()) {
    return <>{props.children}</>;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={GOOGLE_RECAPTCHA_SITE_KEY!}>
      {props.children}
    </GoogleReCaptchaProvider>
  );
};

export const useUpdateRecaptcha = () => {
  const {executeRecaptcha} = useGoogleReCaptcha();
  const getRecaptchaToken = async () => {
    if (!hasCaptchaSiteKey()) {
      return;
    }
    if (!executeRecaptcha) {
      datadogLogs.logger.info('Execute recaptcha not yet available');
      return;
    }
    const token = await executeRecaptcha();
    datadogLogs.logger.info(
      `'\nRecaptcha token: ' \n...${token.substring(token.length - 4, token.length)}\n`
    );
    return token;
  };

  return {
    getRecaptchaToken,
  };
};

export const RecaptchaElement = (props: RecaptchaProps) => {
  const {executeRecaptcha} = useGoogleReCaptcha();

  useEffect(() => {
    const verifyCallback = async () => {
      if (!executeRecaptcha) {
        datadogLogs.logger.error('Execute recaptcha not yet available');
        return;
      }
      const token = await executeRecaptcha();
      datadogLogs.logger.info(`'\nRecaptcha token: ' \n...${token.substring(token.length - 4, token.length)}\n`);
      props.onVerify(token);
    };
    verifyCallback();
    return () => {};
  }, [executeRecaptcha, props.onVerify, props.refreshReCaptcha]);

  return null;
};
export const Recaptcha = (props: RecaptchaProps) => {
  return (
    // <RecaptchaProvider>
    <RecaptchaElement
      onVerify={props.onVerify}
      refreshReCaptcha={props.refreshReCaptcha}
    />
    // </RecaptchaProvider>
  );
};

export default Recaptcha;
